const KEYS = {
  SETUP_TOKEN: 'BLOX_MFA_SETUP_TOKEN',
  COGNITO_ACCESS: 'BLOX_MFA_COGNITO_ACCESS',
  EMAIL: 'BLOX_MFA_EMAIL',
  SESSION: 'BLOX_MFA_SESSION',
  USER_ID: 'BLOX_MFA_USER_ID',
} as const;

export function clearMfaSessionStorage() {
  Object.values(KEYS).forEach((key) => sessionStorage.removeItem(key));
}

export function storeMfaSetupContext(
  setupToken: string,
  cognitoAccessToken: string,
  email: string,
) {
  sessionStorage.setItem(KEYS.SETUP_TOKEN, setupToken);
  sessionStorage.setItem(KEYS.COGNITO_ACCESS, cognitoAccessToken);
  sessionStorage.setItem(KEYS.EMAIL, email);
}

export function storeMfaTotpContext(session: string, userId: string | number, email: string) {
  sessionStorage.setItem(KEYS.SESSION, session);
  sessionStorage.setItem(KEYS.USER_ID, String(userId));
  sessionStorage.setItem(KEYS.EMAIL, email);
}

export function readMfaSetupContext(): {
  setupToken: string;
  cognitoAccessToken: string;
  email: string;
} | null {
  const setupToken = sessionStorage.getItem(KEYS.SETUP_TOKEN);
  const cognitoAccessToken = sessionStorage.getItem(KEYS.COGNITO_ACCESS);
  const email = sessionStorage.getItem(KEYS.EMAIL);
  if (!setupToken || !cognitoAccessToken || !email) {
    return null;
  }
  return { setupToken, cognitoAccessToken, email };
}

export function readMfaTotpContext(): {
  session: string;
  userId: string;
  email: string;
} | null {
  const session = sessionStorage.getItem(KEYS.SESSION);
  const userId = sessionStorage.getItem(KEYS.USER_ID);
  const email = sessionStorage.getItem(KEYS.EMAIL);
  if (!session || !email) {
    return null;
  }
  return { session, userId: userId || '', email };
}
